import { Koi } from '@ksyos/koi';
import { FinanceSearchField } from '@common/enums/financeSearchField';
import { csProcessIdRegex, numberRegex } from '@common/utils/regularExpressions';
import { replaceKoiError } from './replaceKoiError';

export const financingSearchFilterTextSchema = Koi.alternatives().conditional('searchField', [
    {
        is: FinanceSearchField.processNumber,
        then: Koi.string()
            .pattern(csProcessIdRegex)
            .error((errors) => replaceKoiError(errors, 'string.pattern.base', 'string_numeric')),
    },
    {
        is: FinanceSearchField.relationNumber,
        then: Koi.string()
            .pattern(numberRegex)
            .error((errors) => replaceKoiError(errors, 'string.pattern.base', 'string_numeric')),
    },
    {
        is: FinanceSearchField.requesterPractitionerUid,
        then: Koi.string()
            .pattern(numberRegex)
            .error((errors) => replaceKoiError(errors, 'string.pattern.base', 'string_numeric')),
    },
    {
        is: Koi.valid(FinanceSearchField.organizationName, FinanceSearchField.groupName).required(),
        otherwise: Koi.string().max(255).optional(),
        then: Koi.string().max(255).required(),
    },
]);
